import { APP_NAME } from "../../core/app-meta.ts";
import { cn } from "../ui/index.ts";

/** Chemin du logo Ligam servi depuis `public/` (assets partagés). */
export const APP_LOGO_SRC = "/favicon-196.png";

/** Logo Ligam complet — icône + mot-clé « ligam », fond transparent. */
export const APP_WORDMARK_SRC = "/logo-large.png";

/** Logo Ligam (image de marque) — carré arrondi. */
export function AppLogo({
  size = 28,
  className,
  decorative = false,
}: {
  size?: number;
  className?: string;
  decorative?: boolean;
}) {
  return (
    <img
      src={APP_LOGO_SRC}
      width={size}
      height={size}
      alt={decorative ? "" : APP_NAME}
      aria-hidden={decorative || undefined}
      draggable={false}
      className={cn("shrink-0 select-none object-contain", className)}
    />
  );
}

/** Logo Ligam complet (icône + mot-clé) — fond transparent. */
export function AppWordmark({
  className,
  decorative = false,
}: {
  className?: string;
  decorative?: boolean;
}) {
  return (
    <img
      src={APP_WORDMARK_SRC}
      alt={decorative ? "" : APP_NAME}
      aria-hidden={decorative || undefined}
      draggable={false}
      className={cn("select-none object-contain", className)}
    />
  );
}
